import {createContext} from 'react'

const NotaInterconsultaContext = createContext()

export default NotaInterconsultaContext